import { Api } from 'constants/api';
import { Delays } from 'constants/delays';
import { Routes } from 'constants/routes';
import { System } from 'constants/system';

export default {
  Api: Api,
  System: System,
  Delays: Delays,
  Routes: Routes,
};
